import moment from "moment";

export const getOnGoingMaintenance = (incidents, incidentsStatusesData) => {
  const onGoingMaintenance: any = [];

  incidentsStatusesData &&
    incidentsStatusesData.forEach((incidentsStatus) => {
      if (
        incidentsStatus.status === "OP" &&
        incidentsStatus.incident_mini.is_planned
      ) {
        const ongoing = incidents.find(
          (incident) => incident.id === incidentsStatus.incident
        );
        if (ongoing) {
          onGoingMaintenance.push(ongoing);
        }
      }
    });

  return onGoingMaintenance;
};

export const segregateIncidentsOnStatus = (
  incidents,
  incidentsStatusesData
) => {
  const pastIncidents: any = [];
  const liveIncidents: any = [];

  incidentsStatusesData &&
    incidentsStatusesData.forEach((incidentsStatus) => {
      if (incidentsStatus.status === "CL") {
        const closed = incidents.find(
          (incident) => incident.id === incidentsStatus.incident
        );
        if (closed) {
          closed.status = incidentsStatus.status;
          pastIncidents.push(closed);
        }
      } else if (
        incidentsStatus.status === "OP" &&
        !incidentsStatus.incident_mini.is_planned
      ) {
        const opened =
          incidents &&
          incidents.length &&
          incidents.find(
            (incident) => incident.id === incidentsStatus.incident
          );
        if (opened) {
          opened.status = incidentsStatus.status;
          liveIncidents.push(opened);
        }
      }
    });

  return {
    pastIncidents,
    liveIncidents,
  };
};

export const getPlannedIncidents = (incidents, incidentsStatusesData) => {
  const today = moment().utc().format();
  const plannedIncidents: any = [];

  incidentsStatusesData &&
    incidentsStatusesData.forEach((incidentsStatus) => {
      if (incidentsStatus.status === "PL") {
        const planned = incidents.find(
          (incident) => incident.id === incidentsStatus.incident
        );

        if (
          planned &&
          (new Date(planned.start_time) as any) - (new Date(today) as any) <=
            3600000 * 24 * 7
        ) {
          planned.status = incidentsStatus.status;
          plannedIncidents.push(planned);
        }
      }
    });

  return plannedIncidents;
};
